export const baseUrl = 'https://api.themoviedb.org/3'
export const API_KEY = '3cdd94267cb047f5f3dd57e25cb81f5a'
export const imageUrl = 'https://image.tmdb.org/t/p/original'
